import React from 'react'
import PropTypes from 'prop-types'

import StringUtil from '@leverege/string-util'

import { Dialog, Button } from '@leverege/ui-elements'
import { TextInput, LabelGroup, Text, Flex } from '~/views'

function Buttons( { onClose, onCreate } ) {
  return [
    <Button
      key={1}
      onClick={onClose}>Cancel
    </Button>,
    <Button
      key={2}
      onClick={onCreate}>Create
    </Button>
  ]
}

export default class CustomNetworkDialog extends React.Component {
  
  static propTypes = {
    onCreate : PropTypes.func,
    onCancel : PropTypes.func,
    title : PropTypes.string,
    create : PropTypes.string,
    cancel : PropTypes.string
  }

  static defaultProps = {
    create : 'Create',
    cancel : 'Cancel',
    title : 'Create Custom Network'
  }

  constructor( props ) {
    super( props );
    this.onCreate = this.onCreate.bind( this );
    this.onCancel = this.onCancel.bind( this );
    this.onChange = this.onChange.bind( this );
    this.state = { network : { type : 'custom' } }
  }

  onCreate() {
    const network = { ...this.state.network }
    if ( StringUtil.isEmpty( network.name ) || 
         StringUtil.isEmpty( network.subtype ) || 
         StringUtil.isEmpty( network.aliasKeys ) ) {
      return
    }
    let keys
    if ( Array.isArray( network.aliasKeys ) ) {
      keys = network.aliasKeys
    } else if ( network.aliasKeys.split ) {
      keys = network.aliasKeys.split( ',' )
    } else {
      keys = []
    }
    for ( let n = 0; n < keys.length; n++ ) {
      if ( StringUtil.isEmpty( keys[n] ) ) {
        return
      }
    }

    if ( this.props.onCreate ) {
      this.props.onCreate( network )
    }
  }

  onCancel() {
    if ( this.props.onCancel ) {
      this.props.onCancel()
    }
  }

  onChange( key, value, err ) {
    if ( err ) {
      return
    }
    const network = { ...this.state.network }
    network[key] = value
    this.setState( { network } )
  }

  render() {
    const { create, cancel, title, onCreate, onCancel, show = true, ...rest } = this.props;
    const { network } = this.state

    return (
      <Dialog
        title={title}
        onClose={onCancel}
        buttons={<Buttons onClose={this.onCancel} onCreate={this.onCreate} />}
        show={show}>
        <Flex variant="vSpace" direction="column" align="stretch">
          <LabelGroup>
            <label>Name</label>
            <TextInput
              hint="Name..."
              value={network.name} 
              changeOnReturn 
              onChange={( v, err ) => this.onChange( 'name', v, err )} />
          </LabelGroup>
          <LabelGroup>
            <label>Network Id</label>
            <TextInput
              hint="Desired network id. eg. my-network"
              value={network.subtype}
              changeOnReturn
              acceptKey={subtypeValidator}
              onChange={( v, err ) => { this.onChange( 'subtype', v, err ) }} />
          </LabelGroup>
          <LabelGroup>
            <label />
            <Text style={{ textAlign : 'right' }} type="dim">This is used to reference the network from custom code</Text>
          </LabelGroup>
          <LabelGroup>
            <label>Value Names</label>
            <TextInput
              hint="eg. esn, mac, devui"
              value={network.aliasKeys}
              changeOnReturn
              acceptKey={keyValidator}
              onChange={( v, err ) => { this.onChange( 'aliasKeys', v, err ) }} />
          </LabelGroup>
          <LabelGroup>
            <label />
            <Text type="dim">Comma separate list of the possible value names</Text>
          </LabelGroup>
        </Flex>
      </Dialog>
    )
  }
}

function keyValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /[a-zA-Z0-9_\-,]/.test( inp ) ) {
    return true;
  }
  return false;
}

function subtypeValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /[a-zA-Z0-9_\-]/.test( inp ) ) {
    return true;
  }
  return false;
}
